// removed by extract-text-webpack-plugin
module.exports = {"root":"popup--root--2cQ_b4-W","overlay":"popup--overlay--oJdG83x7","modal":"popup--modal--3RqBD4iN","close":"popup--close--2L-GVTKp"};


//////////////////
// WEBPACK FOOTER
// ./components/popup/styles.css
// module id = ./components/popup/styles.css
// module chunks = 0